/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Locked_OnInputs */

const en_explorer_info_property_locked_on = /** @type {(inputs: Explorer_Info_Property_Locked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked On`)
};

const fr_explorer_info_property_locked_on = /** @type {(inputs: Explorer_Info_Property_Locked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouille le`)
};

const de_explorer_info_property_locked_on = /** @type {(inputs: Explorer_Info_Property_Locked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingesperrt`)
};

const it_explorer_info_property_locked_on = /** @type {(inputs: Explorer_Info_Property_Locked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloccato`)
};

const ru_explorer_info_property_locked_on = /** @type {(inputs: Explorer_Info_Property_Locked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заблокировано`)
};

const es_explorer_info_property_locked_on = /** @type {(inputs: Explorer_Info_Property_Locked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueado`)
};

const zh_cn2_explorer_info_property_locked_on = /** @type {(inputs: Explorer_Info_Property_Locked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`锁定`)
};

const ja_explorer_info_property_locked_on = /** @type {(inputs: Explorer_Info_Property_Locked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロックオン`)
};

const hi_explorer_info_property_locked_on = /** @type {(inputs: Explorer_Info_Property_Locked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस दिन लॉक किया गया`)
};

const pt_pt2_explorer_info_property_locked_on = /** @type {(inputs: Explorer_Info_Property_Locked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travado em`)
};

/**
* | output |
* | --- |
* | "Locked On" |
*
* @param {Explorer_Info_Property_Locked_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_locked_on = /** @type {((inputs?: Explorer_Info_Property_Locked_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Locked_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_locked_on(inputs)
	if (locale === "de") return de_explorer_info_property_locked_on(inputs)
	if (locale === "it") return it_explorer_info_property_locked_on(inputs)
	if (locale === "ru") return ru_explorer_info_property_locked_on(inputs)
	if (locale === "es") return es_explorer_info_property_locked_on(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_locked_on(inputs)
	if (locale === "ja") return ja_explorer_info_property_locked_on(inputs)
	if (locale === "hi") return hi_explorer_info_property_locked_on(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_locked_on(inputs)
	return en_explorer_info_property_locked_on(inputs)
});